import React, { useContext, useEffect, useState } from 'react';
import { DataTableComponent } from '../../components/data-table/data-table.component';
import { BuildingsContext } from '../../store';
import { BuildingsService } from '../../services/buildings/buildings.service';
import { Hub } from '@aws-amplify/core'
import { MapperService } from '../../services/mapper/mapper.service';

export default function BuildingsContent() {
  const buildingsService = new BuildingsService();
  const mapperService = new MapperService();
  const emptyArr: any = [];

  const { buildings, buildingsCache, columns, mode, setBuildings, options, pagination, setViewMode, sort, search, paginate } = useContext(BuildingsContext);
  const [loading, setLoading] = useState(true);

  const toggleView = () => {
    const viewMode = mode === 'table' ? 'calendar' : 'table';
    setViewMode(viewMode);
  }

  async function fetchData() {
    setBuildings(emptyArr);
    setLoading(true);
    const buildingsDetails = await buildingsService.listBuildingsMoreDetails();
    const readyBuildings = mapperService.buildings(buildingsDetails);
    setBuildings(readyBuildings);
    setLoading(false);
  };

  const registerForAuthEvents = () => {
    Hub.listen('auth', (data)=>{
      if(data.payload.event === 'signIn') {
        fetchData();
      }
    });
  }

  useEffect(() => {
    fetchData();
    registerForAuthEvents();
    // eslint-disable-next-line
  }, []);

  

  const sortTable = (fieldName: string, sortDirection: string) => {
    const params = {fieldName, sortDirection};
    return sort(params);
  }

  const searchTable = (fieldName: string, searchString: string) => {
    const params = {fieldName, searchString}
    return search(params);
  }

  return (
    <DataTableComponent
      loading={loading}
      columns={columns}
      data={buildings}
      allData={buildingsCache}
      mode={mode}
      options={options}
      toggleView={toggleView}
      refresh={fetchData}
      sort={sortTable}
      search={searchTable}
      pagination={pagination}
      paginate={paginate}
      total={buildingsCache?.length || 0}
      title='building list'
    />
  );
}
